import { render, staticRenderFns } from "./exam-detail-view.vue?vue&type=template&id=7bb62550"
import script from "./exam-detail-view.vue?vue&type=script&lang=js"
export * from "./exam-detail-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports